// extracted by mini-css-extract-plugin
export default {"page":"MeusCupons_page__1yOJX","containerImg":"MeusCupons_containerImg__RsOuy","vazio":"MeusCupons_vazio__FjX79"};